import { useState, useEffect, useContext, UIEvent, SyntheticEvent  } from "react";
import { Button, Table as BootstrapTable } from "react-bootstrap";

import "./editable-table.scss";
import { BsSave, BsTrash } from "react-icons/bs";
import { FaCheck } from "react-icons/fa";
import { GrRevert } from "react-icons/gr";
import { LiaPlusSolid } from "react-icons/lia";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";

import { Fragment } from "react";
import TextInput from "../../../shared/components/text-input/text-input";
import Tooltip from "../../../shared/components/tooltip/tooltip";
import AuthContext from "../../../shared/context/auth-context";
import { roleAdmin, roleRead, roleWrite } from "../../constants/user-roles";
import { IDetailPageData } from "../../utils/api";
import { usePrompt } from "../../utils/use-prompt";
import { createUUID, validateLoadingStatusNew, getTheLastParam } from "../../utils/utils";
import CheckboxInput from "../checkbox-input/checkbox-input";
import ConfirmationPopup from "../confirmation-popup/confirmation-popup";
import CustomCheckbox from "../custom-checkbox/custom-checkbox";
import { IColumn, ITableRowData } from "../normal-table/normal-table";
import Popup from "../popup/popup";
import UserPopup from "../user-popup/user-popup";

export interface IEditableTableConfig {
  columns: IColumn[];
  hideButtons?: string[];
  dataUrl?: string;
  fetchedData?: IDetailPageData;
  inputData?: string;
  localDeleteOn?: boolean;
  unblockInput?: boolean;
  allStatus?: string | null;
  allStatusPost?: string | null;
  allStatusPostError?: string | undefined;
  allStatusError?: string | undefined;
  allStatusDelete?: string | null;
  allStatusTablePost?: string | null;
  postSingleError?: string | null;
  emptyCellMsg?: string;
  uniqueKeys?: string[],
  deletedFields?: ITableRowData[];
  navigateToAfterSave?: string | null;
  toggleShowInput?: boolean;
  defaultSortCol?: string;
  modalColumns?: IColumn[];
  revertAction?: boolean;
  noEmptyTable?: boolean;
  primaryKeyIsRequired?: boolean;
  promptText?: string;
  revertAlltrigger?: undefined | boolean,
  revertFromParent?: undefined | ITableRowData,
  disabledBytheParent?: boolean,
  passChildDataToParent?: (data: ITableRowData[]) => void;
  saveData: (data: ITableRowData[], ids: string[], fullDataToBeDeleted?: ITableRowData[]) => void;
  getData?: (url: string) => void;
  handleOnDelete?: (ids: string[]) => void;
  updateParentWithTheActualList?: (data: ITableRowData[]) => void;
  generateTable?: (id: string) => void;
  renderExtraTableBtns?: () => JSX.Element;
  renderExtraPopUpButtons?: (data: ITableRowData) => JSX.Element;
  filterOnDeleteLocalVals?: (copyRowData :ITableRowData[],recentlyDeletedList : string[]) => ITableRowData[];
  sortBy?: (searchQuesry: string) => void;
  recentlyDeletedFullFromParent?: ITableRowData[] | undefined;
  allowOnClick?: string | undefined
}

interface IState {
  rowData: ITableRowData[];
  showPopup?: boolean;
  currentSelectedRow: ITableRowData | undefined;
  mode: string;
  fetchedId?: string;
  selectedRows: string[];
  newlyCreated: ITableRowData[];
  initialRowsAmount: number;
}

interface ISortedBy {
  column: undefined | string;
  direction: undefined | string;
}

const EditableTable = ({ columns, allStatus, promptText, disabledBytheParent, updateParentWithTheActualList, passChildDataToParent, noEmptyTable, revertFromParent, primaryKeyIsRequired, revertAlltrigger, revertAction, postSingleError, recentlyDeletedFullFromParent, renderExtraTableBtns, renderExtraPopUpButtons, allStatusTablePost, defaultSortCol, uniqueKeys, hideButtons, sortBy, generateTable, filterOnDeleteLocalVals, navigateToAfterSave, toggleShowInput, unblockInput, deletedFields, dataUrl, inputData, emptyCellMsg, localDeleteOn, allStatusPost, allStatusPostError, allStatusError, allStatusDelete, fetchedData, getData, saveData, handleOnDelete, allowOnClick }: IEditableTableConfig) => {
  const [data, setData] = useState<IState>({
    rowData: fetchedData?.rowData || [],
    showPopup: false,
    initialRowsAmount: 0,
    currentSelectedRow: undefined,
    mode: "",
    fetchedId: "",
    selectedRows: [],
    newlyCreated: [],
  });
  const [initialRowsData, setinitialRowsData] = useState<ITableRowData[]>([]);
  const [recentlyDeleted, setRecentlyDeleted] = useState<string[]>([]);
  const [recentlyDeletedFull, setRecentlyDeletedFull] = useState<ITableRowData[]>([]);
  const [initialInput, setInitialInput] = useState("");
  const [checkAll, setCheckAll] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const [sortedByCol, setSortedByCol] = useState<ISortedBy>({column: undefined, direction: undefined});

  const [primaryKeyStatus, setPrimaryKeyStatus] = useState(true);

  const [isInputNew, setIsInputNew] = useState(false);
  const [isEditedRow, setIsEditedRow] = useState(false);
  const { flag, setFlag, next } = usePrompt(data.newlyCreated.length !== 0 || isInputNew || recentlyDeleted.length !== 0 ||  isEditedRow ? true : false);

  const [readOnlyState, setReadOnlyState] = useState(false);
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (updateParentWithTheActualList) {
      updateParentWithTheActualList(data.rowData);
    }
  }, [data]);

  useEffect(() => {
    if (passChildDataToParent) {
      if (getTheLastParam() !== "new") {
        const filterOutDeleted = data.rowData.filter((row) => recentlyDeleted.indexOf(row.id) === -1);
        passChildDataToParent(filterOutDeleted);
      } else {
        passChildDataToParent(data.rowData);
      }
    }
    if (primaryKeyIsRequired) {
      let findPrimaryKey = false;
      data.rowData.forEach((rowData) => {
        if (rowData.primary_key && !findPrimaryKey && recentlyDeleted.indexOf(rowData.id) === -1) {
          findPrimaryKey = true;
        }
      });
      setPrimaryKeyStatus(!findPrimaryKey);
    }
  }, [data]);

  useEffect(() => {
    if (recentlyDeletedFullFromParent && recentlyDeletedFullFromParent?.length !== 0) {
      const extrIds = recentlyDeletedFullFromParent.map(row => row.id);
      setRecentlyDeleted(extrIds);
      setRecentlyDeletedFull(recentlyDeletedFullFromParent);
    }
  }, [recentlyDeletedFullFromParent]);

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.length <= 1 && rolesArray.indexOf(roleRead) !== -1 && !authCtx.systemAdmin){
      setReadOnlyState(true);
    } else {
      setReadOnlyState(false);
    }
  }, [authCtx.selectedTenant.roles]);

  useEffect(() => {
    if (revertFromParent) {
      revertRowHandler(revertFromParent.id, revertFromParent.edited);
    }
  }, [revertFromParent]);

  useEffect(() => {
    if (defaultSortCol) {
      setSortedByCol({column: defaultSortCol, direction: "asc"});
    }
  }, [defaultSortCol]);

  useEffect(() => {
    if (allStatusPost === "completed" && !flag) {
      next();
      if (navigateToAfterSave && !allStatusError && !allStatusPostError) {
        navigate(`${navigateToAfterSave}`);
      }
    }
  }, [allStatusPost, flag]);

  useEffect(() => {
    if (fetchedData && !postSingleError) {
      if (allStatusPost === "completed") {
        setData({ ...data, newlyCreated: [] });
        setIsEditedRow(false);
        setIsInputNew(false);
        setRecentlyDeletedFull([]);
        setRecentlyDeleted([]);
      }
    }
  }, [allStatusPost]);

  useEffect(() => {
    if (allStatusDelete === "completed") {
      setData({ ...data, selectedRows: [] });
    }
  }, [allStatusDelete]);

  useEffect(() => {
    if (deletedFields) {
      setRecentlyDeletedFull([...deletedFields]);
      const getOnlyIds = deletedFields.map(fieldData => fieldData.id);
      setRecentlyDeleted(getOnlyIds);
    }
  }, [deletedFields]);

  useEffect(() => {
    if (initialInput === "") {
      inputData && setInitialInput(inputData);
    }
    if (initialInput !== inputData && initialInput) {
      setIsInputNew(true);
    } else {
      setIsInputNew(false);
    }
  }, [inputData]);

  useEffect(() => {
    // to avoid mutation we need to clone it
    const cloneData = fetchedData && [...fetchedData.rowData];
    cloneData &&  setinitialRowsData(cloneData);
  }, [fetchedData]);

  useEffect(() => {
    if (revertAlltrigger !== undefined && fetchedData) {
      if (recentlyDeletedFullFromParent && recentlyDeletedFullFromParent?.length > 0) {
        // csv/db import
        setData({ ...data, rowData: [...recentlyDeletedFullFromParent], newlyCreated: [], initialRowsAmount: recentlyDeletedFullFromParent.length });
        setinitialRowsData([...recentlyDeletedFullFromParent]);
      } else {
        // normal flow
        setData({ ...data, rowData: [...initialRowsData], newlyCreated: [], initialRowsAmount: fetchedData.rowData.length });
      }
      setIsEditedRow(false);
      setIsInputNew(false);
      setRecentlyDeletedFull([]);
      setRecentlyDeleted([]);
    }
  }, [revertAlltrigger]);
  
  useEffect(() => {
    if (readOnlyState) {
      setFlag(false);
      next();
    }
  }, [flag]);

  const revertRowHandler = (id: string, editedStatus : undefined | boolean) => {
    const removeRewivedFromDeletedFull = recentlyDeletedFull.filter((row) => row.id !== id);
    const removeRewivedFromDeleted = recentlyDeleted.filter((rowId) => rowId !== id);

    setRecentlyDeletedFull(removeRewivedFromDeletedFull);
    setRecentlyDeleted(removeRewivedFromDeleted);

    if (editedStatus) {
      const isNewlyCreated = fetchedData?.rowData.find((row) => row.id === id);
      const findSelectedRow = data.rowData.find((row) => row.id === id);
      const determineSelectedRow = findSelectedRow ? [{...findSelectedRow, editedStatus: false}] : [];

      const revertToOriginalRow = data.rowData.map(row => {
        if (row.id === id) {
          return isNewlyCreated? isNewlyCreated : row;
        }
        return row;
      });
      setData({...data, rowData: !isNewlyCreated ? [...data.rowData, ...determineSelectedRow] : revertToOriginalRow });
    } else {
      const isNewlyCreated = fetchedData?.rowData.find((row) => row.id === id);
      const findSelectedRow = data.rowData.find((row) => row.id === id);
      const determineSelectedRow = findSelectedRow ? [{...findSelectedRow}] : [];
  
      setData({...data, newlyCreated: !isNewlyCreated ? [...data.newlyCreated, ...determineSelectedRow] : data.newlyCreated });
    }
  };

  useEffect(() => {
    if (fetchedData) {
      if (fetchedData.id && data.fetchedId !== fetchedData.id) {
        setRecentlyDeletedFull([]);
        setRecentlyDeleted([]);
      }
      let result = { ...data, fetchedId: fetchedData.id, rowData: [...fetchedData.rowData], initialRowsAmount: fetchedData.rowData.length };
      if (fetchedData.id) {
        if (!fetchedData.csvImport) {
          result = { ...data, fetchedId: fetchedData.id, rowData: [...fetchedData.rowData, ...data.newlyCreated]};
        }
        else {
          result = { ...data, fetchedId: fetchedData.id, rowData: [...data.rowData, ...fetchedData.rowData], newlyCreated: [...fetchedData.rowData, ...data.newlyCreated]};
          setinitialRowsData([]);
        }
      }
      setData(result);
    }
  }, [fetchedData?.rowData]);

  const renderRows = () => {
    if (!data?.rowData) {
      return;
    }

    let result = [...data.rowData];

    result = result.filter(row => {
      return columns.some(({key}) => row[key] && row[key].toString().toLowerCase().includes(searchInputValue.toLowerCase()));
    });

    return result.map((rowData) => {
      const isDeleted = recentlyDeleted.indexOf(rowData.id) !== -1 ? true : false;
      const isReadOnlyState = isDeleted? true : (readOnlyState ? readOnlyState : !unblockInput);
      return (
        <tr className={`editableTable-row ${isDeleted? "deleted" : ""} ${fetchedData?.archived ? "archived" : ""}`} key={rowData.id} data-id={rowData.id} onClick={(event => handleOnRowClick(event, isDeleted))}>
          <td key={rowData.id}><span><CheckboxInput rowData={rowData} id={rowData.id} readOnlyState={isReadOnlyState}  checked={isDeleted? false : isSelected(rowData.id)} onChange={() => handleOnSelectRow(rowData.id)} /></span></td>
          {columns.map((column) => {
            let columnData = rowData[column.key];

            switch (column.key) {
              case "primary_key":
                columnData = (
                  <Fragment>
                    {rowData.primary_key && <FaCheck className="editableTable-keyColIcon" />}
                  </Fragment>
                );
                break;
              case "valid":
                columnData = (
                  <Fragment>
                    {rowData.valid? <FaCheck className="editableTable-validColIcon" /> : <RxCross2 className="editableTable-unvalidColIcon" />}
                  </Fragment>
                );
                break;
              case "roles":
                columnData = (
                  <Fragment>
                    <CustomCheckbox name={rowData.name} disabled={!unblockInput || !authCtx.systemAdmin} readOnlyState={readOnlyState} initialValue={columnData && columnData.indexOf(roleAdmin) !== -1} handleOnSelectRole={handleOnSelectRole} id={rowData.id} text={roleAdmin} />
                    <CustomCheckbox name={rowData.name} disabled={!unblockInput} readOnlyState={readOnlyState} initialValue={columnData && columnData.indexOf(roleWrite) !== -1} handleOnSelectRole={handleOnSelectRole} id={rowData.id} text={roleWrite} />
                    <CustomCheckbox name={rowData.name} disabled={!unblockInput} readOnlyState={readOnlyState} initialValue={columnData && columnData.indexOf(roleRead) !== -1} handleOnSelectRole={handleOnSelectRole} id={rowData.id} text={roleRead} />
                  </Fragment>
                );
            }
            if (columnData && column.dataType.type === "enumeration") {
              const enumOption = column.dataType.values.find(v => v.id === columnData);
              columnData = enumOption?.name || columnData;
            }
            return <td className="editableTable-regularTd" key={column.key}><span className={!columnData && emptyCellMsg? "warning" : ""}>{columnData != undefined ? columnData : (emptyCellMsg? emptyCellMsg : "")}</span></td>;
          })}
          {revertAction && (isDeleted || rowData.editedStatus) && <td id={"revertBtn"} onClick={() => revertRowHandler(rowData.id, rowData.editedStatus)} className="editableTable-editRowIcon"><GrRevert id={"revertBtn"} /></td>}
        </tr>
      );
    });
  };

  const handleOnRowClick = (evt: UIEvent, isDeleted: boolean) => {
    if (isDeleted || allowOnClick) {
      return;
    }
    if ((/*(evt.target as Element).id !== "checkbox" && */dataUrl !== "tenants/new" && dataUrl !== "user-groups/new") && (evt.target as Element).id !== "revertBtn") {
      const clickedId = (evt.currentTarget as HTMLTableRowElement).dataset.id;
      const clickedRow = data.rowData?.find((el) => el.id === clickedId);
      setData({ ...data, showPopup: true, currentSelectedRow: clickedRow ? { ...clickedRow } : undefined });
    }
  };

  const handleOnSelectRow = (id: string) => {
    const result = [...data.selectedRows];
    if (result.indexOf(id) === -1) {
      result.push(id);
      setData({ ...data, selectedRows: result });
    } else {
      const filtered = result.filter((el) => el !== id);
      setData({ ...data, selectedRows: filtered });
    }
  };

  const handleOnSelectAllRows = () => {
    if (data.rowData && !checkAll) {
      const rowDataCopy = data.rowData && [...data.rowData];
      const result = rowDataCopy.map((row) => row.id);
      setData({ ...data, selectedRows: result });
      setCheckAll(true);
    } else {
      setData({ ...data, selectedRows: [] });
      setCheckAll(false);
    }
  };

  const isSelected = (id:string) => data.selectedRows.indexOf(id) !== -1;

  const handleOnSelectRole = (id: string, role: string, status: boolean) => {    
    const rowData = [...data.rowData];
    const result = rowData.map((row) => { 
      if (row.id === id && status) {
        const roles = row.roles ? row.roles : [];
        return {...row, roles: [...roles, role]};
      } else if (row.id === id && !status) {
        const roles = row.roles ? row.roles : [];
        roles.splice(roles.indexOf(role), 1);
      }      
      return row;
    });
    setData({ ...data, rowData: result });
  };

  const handlePopupClosed = (result: ITableRowData | undefined) => {
    if (result && data.currentSelectedRow?.id) {
      // edit
      const currentData = data.rowData;
      const editedRowData = currentData.map(obj => {
        if (obj.id === data.currentSelectedRow?.id) {
          const resultCopy = revertAction? { ...result, editedStatus: true } : {...result};
          return resultCopy;
        }
        return obj;
      });
      setIsEditedRow(true);
      setData({ ...data, rowData: filterOnDeleteLocalVals? filterOnDeleteLocalVals(editedRowData, recentlyDeleted) : editedRowData, currentSelectedRow: undefined, showPopup: false });
    } else if (result) {
      // create new
      const newID = createUUID();
      const popupResult:ITableRowData = { ...result, id: result.id !== ""? result.id : newID };

      const currentData = data.rowData;
      currentData.push(popupResult);

      let filteredRecentlyDeletedFull = [...recentlyDeletedFull];
      let filteredRecentlyDeleted = [...recentlyDeleted];

      if (result.id) {
        // edge case: if we add again a label which we previously deleted
        filteredRecentlyDeletedFull = filteredRecentlyDeletedFull.filter(row =>
          !(result.datamodel_field_id === row.datamodel_field_id && result.datamodel_reference_field_id === row.datamodel_reference_field_id));
        filteredRecentlyDeleted = filteredRecentlyDeleted.filter(id => (result.id !== id));
      }

      setRecentlyDeleted(filteredRecentlyDeleted);
      setRecentlyDeletedFull(filteredRecentlyDeletedFull);
      setData({ ...data, rowData: filterOnDeleteLocalVals? filterOnDeleteLocalVals(currentData, recentlyDeleted) : currentData, newlyCreated: [...data.newlyCreated, { ...popupResult }], currentSelectedRow: undefined, showPopup: false });
    } else {
      // just quit
      setData({ ...data, showPopup: false, currentSelectedRow: undefined });
    }
  };

  const handleUserPopupClosed = (result: ITableRowData[] | undefined) => {
    if (result) {      
      setData({ ...data, newlyCreated: [...data.newlyCreated, ...result ], rowData: [...data.rowData, ...result],  currentSelectedRow: undefined, showPopup: false });
    } else {
      setData({ ...data, showPopup: false, currentSelectedRow: undefined });
    }
  };

  const renderPopup = () => {
    if (data?.showPopup) {
      if (dataUrl === "tenants/new" || dataUrl === "user-groups/new") {
        return (
          <UserPopup
            existingUsers={data.rowData}
            columns={columns}
            mode={data.currentSelectedRow?.id ? "Edit" : "New"}
            buttonText={data.currentSelectedRow?.id ? "Save changes" : "Add"}
            show={data.showPopup}
            handlePopupClosed={handleUserPopupClosed}
            dataUrl={dataUrl}
            unblockInput={unblockInput}
          />
        );
      }
      else {
        // has to be set before the initial render to have default vals for the controlled inputs
        let setUniqueDefaults = {};
        uniqueKeys?.forEach((key) => {
          setUniqueDefaults =  {...setUniqueDefaults, [key] : ""};
        });
        return (
          <Popup
            mode={data.currentSelectedRow?.id ? "Edit" : "New"}
            buttonText={data.currentSelectedRow?.id ? "Save changes" : "Add"}
            colums={[...columns]}
            values={data.currentSelectedRow}
            show={data.showPopup}
            handlePopupClosed={handlePopupClosed}
            getData={getData}
            rowsData={data.rowData}
            uniqueKeys={uniqueKeys}
            setUniqueDefaults={setUniqueDefaults}
            renderExtraPopUpButtons={renderExtraPopUpButtons}
          />
        );
      }
    }
    return undefined;
  };

  const handleGenerateClick = () => {
    if (data.fetchedId && generateTable) {
      generateTable(data.fetchedId);
      setConfirmation(false);
    }
  };

  const handleSaveClick = () => {
    if (data?.rowData) {
      // match recently deleted with the initial the state, to filter out localy created then deleted rows
      let allRowsIds = initialRowsData && initialRowsData.map(row => row.id);
      if (allRowsIds && recentlyDeletedFullFromParent && recentlyDeletedFullFromParent?.length !== 0) {
        const extrIds = recentlyDeletedFullFromParent.map(row => row.id);
        allRowsIds = [...allRowsIds, ...extrIds];
      }

      const onlyIdsToBeDeleted:string[] = [];
      const result = allRowsIds && recentlyDeletedFull.filter((row) => {
        if (row.id && allRowsIds.indexOf(row.id) !== -1) {
          onlyIdsToBeDeleted.push(row.id);
        }
        return allRowsIds.indexOf(row.id) !== -1;
      });

      if (getTheLastParam() !== "new") {
        const filterOutDeleted = data.rowData.filter((row) => recentlyDeleted.indexOf(row.id) === -1);
        saveData(filterOutDeleted, onlyIdsToBeDeleted, result);
      } else {
        saveData(data.rowData, onlyIdsToBeDeleted, result);
        setFlag(false);
      }
    }
  };

  const handleOnDeleteClick = () => {
    if (localDeleteOn) {
      let copyRowData = [...data.rowData];
      const copyNewlyCreated = [...data.newlyCreated];      
      const recentlyDeletedList: string[] = [];
      const recentlyDeletedFullLocal: ITableRowData[] = [];

      copyRowData.forEach((row) => {
        if (data.selectedRows.indexOf(row.id) !== -1) {
          recentlyDeletedList.push(row.id);
          recentlyDeletedFullLocal.push(row);
        }
        return row;
      });

      copyRowData = filterOnDeleteLocalVals? filterOnDeleteLocalVals(copyRowData,recentlyDeletedList) : copyRowData;

      setRecentlyDeletedFull([...recentlyDeletedFullLocal, ...recentlyDeletedFull]);
      setRecentlyDeleted([...recentlyDeletedList, ...recentlyDeleted]);
      setData({
        ...data,
        rowData: revertAction? copyRowData : copyRowData.filter((row) => data.selectedRows.indexOf(row.id) === -1),
        selectedRows: [],
        newlyCreated: copyNewlyCreated.filter((row) => data.selectedRows.indexOf(row.id) === -1),
      });
    } else {
      handleOnDelete && handleOnDelete(data.selectedRows);
    }
  };

  const sortColumVals = (key: string) => {
    let defineDirection;
    if (sortedByCol.direction === undefined) {
      defineDirection = "asc";
    } else if (sortedByCol.column !== key) {
      defineDirection = "asc";
    } else if (sortedByCol.column === key && sortedByCol.direction === "asc") {
      defineDirection = "desc";
    } else {
      defineDirection = "asc";
    }
    setSortedByCol({column: key, direction: defineDirection});
    sortBy && sortBy(`?order_by=${key} ${defineDirection}`);
  };

  const defineSortingArrows = (key: string) => {
    if (sortedByCol.direction === undefined) {
      return <RiArrowDownSLine />;
    } else if (sortedByCol.column !== key) {
      return <RiArrowDownSLine />;
    } else if (sortedByCol.column === key && sortedByCol.direction === "desc") {
      return <RiArrowUpSLine />;
    } else {
      return <RiArrowDownSLine />;
    }
  };

  const validateSaveBtnStatus = () => {
    if (data.rowData.length === 0) {
      // empty
      return true;
    }
    else if (noEmptyTable && revertAction) {
      // edit
      const currentData = data.rowData;
      const untouchedAllState:boolean[] = [];
      
      initialRowsData.forEach((rowDataLoc) => {
        let actuallyUntouched = false;

        const findMatch = currentData.find((currentDataLoc) => {
          return rowDataLoc.id === currentDataLoc.id;
        });

        if (findMatch && (rowDataLoc.field_datatype === findMatch.field_datatype && rowDataLoc.text_type === findMatch.text_type && recentlyDeleted.indexOf(rowDataLoc.id) === -1) ) {
          actuallyUntouched = true;
        }
        actuallyUntouched && untouchedAllState.push(actuallyUntouched);
      });
      if (untouchedAllState.length === 0) {
        return true;
      }
    } else if (noEmptyTable && !revertAction && data.rowData.length !== 0) {
      // new
      return false;
    } else {
      return primaryKeyIsRequired? primaryKeyStatus : validateLoadingStatusNew([allStatus, allStatusTablePost, allStatusPost, allStatusDelete]) || !unblockInput || readOnlyState;
    }
  };

  return (
    <div className="editableTable">
      <div className="editableTable-buttonsGroup">
        <TextInput
          type={"text"}
          id={"editableTable-searchUserInput"}
          required={false}
          inputKey={"editableTable-searchUserInput"}
          autofocus={false}
          placeholder={"Type to filter"}
          disabled={fetchedData?.archived}
          handleOnChange={(targetVal) => setSearchInputValue(targetVal)}
        />
        <Tooltip content={"Delete"} direction="top" delay={350} >
          <Button name="delete" disabled={data.selectedRows.length === 0 || fetchedData?.archived} onClick={handleOnDeleteClick} className="tableNormal-delete" variant="primary">
            <BsTrash />
          </Button>
        </Tooltip>
        
        {renderExtraTableBtns && renderExtraTableBtns()}

        <Tooltip content={"Add a new field"} direction="top" delay={350} >
          <Button 
            name="add"
            disabled={validateLoadingStatusNew([allStatus, allStatusTablePost, allStatusPost, allStatusDelete]) || (emptyCellMsg? (recentlyDeletedFull.length === 0) : false) || !unblockInput || readOnlyState || fetchedData?.archived} 
            className="editableTable-new" 
            onClick={() => setData({ ...data, showPopup: true })}>
            <LiaPlusSolid />
          </Button>
        </Tooltip>
        {hideButtons?.indexOf("save") === -1?<Tooltip content={"Save"} direction="top" delay={350} >
          <Button 
            name="save"
            disabled={disabledBytheParent ? disabledBytheParent : validateSaveBtnStatus() || fetchedData?.archived} 
            className="editableTable-save" onClick={handleSaveClick}>
            <BsSave />
          </Button>
        </Tooltip> : ""}
      </div>
      {renderPopup()}

      {flag && <ConfirmationPopup text={promptText} actionButtonDisabled={validateSaveBtnStatus()} show={flag} handleSaveClick={handleSaveClick} handlePopupClosed={() => setFlag(false)} handleContinue={() => { next(); setFlag(false); }}/>}
      {confirmation && <ConfirmationPopup text={"You are about to persist this event to the database, are you sure?"} show={confirmation} handleSaveClick={handleGenerateClick} handlePopupClosed={() => setConfirmation(false)}  />}

      {data.rowData.length !== 0 || (revertAction && recentlyDeleted.length !== 0) ? <div onScroll={(event: SyntheticEvent<HTMLDivElement>) => {
        if (event.currentTarget.scrollTop === 0) {
          setScrolled(false);
        } else {
          !scrolled && setScrolled(true);
        }
      }} className={`${toggleShowInput? "editableTable-container-toggled" : "editableTable-container"} ${scrolled? "scrolled" : ""}`}><BootstrapTable borderless striped>
          <thead>
            <tr
              className={fetchedData?.archived ? "archived" : ""}>
              <th className="editableTable-actionTh" key={"actions"}><span><CheckboxInput checked={data.rowData.length === 0 && data.rowData.length === 0 ? false :  data.selectedRows.length === data.rowData.length} readOnlyState={readOnlyState? readOnlyState : !unblockInput} onChange={() => handleOnSelectAllRows()} /></span></th>
              {columns.map((column) => (
                <th 
                  onClick={() => (!column.nonSortable && sortBy) && sortColumVals(column.key)} 
                  className={`editableTable${!column.nonSortable? "-sortable" : "-nonSortable"} ${column.key === sortedByCol.column? "selectedCol" : ""}`} 
                  key={column.key}>
                  <span>
                    {column.displayName} {(!column.nonSortable && sortBy) && defineSortingArrows(column.key)}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{renderRows()}</tbody>
        </BootstrapTable></div> : <div className="editableTable-noDataMsg">No data to be displayed...</div>}

    </div>
  );
};

export default EditableTable;
